import React, { useState } from 'react';
import './FAQ.css';

export const faqs = [
  {
    question: "How can I book a newspaper ad online?",
    answer: "We are currently enhancing our online booking experience. Currently, we accept ad bookings exclusively via Call and WhatsApp for faster service. Please contact us to book your ad instantly."
  },
  {
    question: "Which newspapers can I book ads in?",
    answer: "We are authorized partners for over 500+ newspapers including Times of India, Hindustan Times, The Hindu, Dainik Jagran, Amar Ujala, Malayala Manorama, and many regional papers."
  },
  {
    question: "What is the cost of booking a newspaper ad?",
    answer: "The cost depends on the newspaper, city, ad type (Text/Display), and number of lines. We offer the lowest rates in the market with a price match guarantee."
  },
  {
    question: "How many days in advance should I book my ad?",
    answer: "We recommend booking at least 2 days in advance for standard ads. For urgent bookings, please contact our support team via WhatsApp or Phone."
  },
  {
    question: "Do you provide proof of publication?",
    answer: "Yes, for most major newspapers, we can provide an e-paper link or a scanned copy of your ad upon request after publication."
  }
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <p className="section-subtitle">Everything you need to know about booking newspaper ads</p>
        
        <div className="faq-grid">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
